<div class="surface-card p-4 border-round-xl border-1 surface-border mb-3 shadow-sm">
  <!-- Header -->
  <div class="flex align-items-center justify-content-between mb-3">
    <div>
      <div class="flex align-items-center gap-2">
        <i class="pi pi-sliders-h text-primary"></i>
        <span class="text-900 font-bold uppercase text-xs">{{ texts.titulo }}</span>
        <p-badge *ngIf="gruposAssociados.length > 0"
                 [value]="gruposAssociados.length + ''"
                 severity="info"></p-badge>
      </div>
      <small class="text-500">{{ texts.descricao }}</small>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-content-center p-3">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4"></p-progressSpinner>
  </div>

  <!-- Estado vazio -->
  <div *ngIf="!loading && gruposAssociados.length === 0" class="text-center p-3">
    <small class="text-500">{{ texts.nenhum }}</small>
  </div>

  <!-- Lista de grupos associados com drag & drop -->
  <div *ngIf="!loading && gruposAssociados.length > 0"
       cdkDropList
       (cdkDropListDropped)="onDrop($event)"
       class="flex flex-column gap-2">

    <div *ngFor="let assoc of gruposAssociados; trackBy: trackById"
         cdkDrag
         class="flex align-items-center gap-2 p-2 surface-50 border-round-lg grupo-item">

      <div class="drag-handle-sm" cdkDragHandle aria-label="Arrastar para reordenar">
        <i class="pi pi-ellipsis-v"></i>
        <i class="pi pi-ellipsis-v"></i>
      </div>

      <span class="flex-1 font-medium text-sm text-900 white-space-nowrap overflow-hidden text-overflow-ellipsis">
        {{ assoc.grupoModificador.nome }}
      </span>

      <p-badge [value]="assoc.grupoModificador.obrigatorio ? texts.obrigatorio : texts.opcional"
               [severity]="assoc.grupoModificador.obrigatorio ? 'danger' : 'info'"
               styleClass="text-xs">
      </p-badge>

      <small class="text-500 white-space-nowrap">{{ getQtdOpcoes(assoc) }} {{ texts.opcoes }}</small>

      <!-- Botao desassociar -->
      <button pButton type="button" icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger p-button-sm"
              (click)="onDesassociar(assoc.id)">
      </button>
    </div>
  </div>

  <!-- Botao gerenciar modificadores -->
  <button pButton type="button" icon="pi pi-plus"
          [label]="texts.adicionar_modificador"
          class="p-button-outlined p-button-sm w-full border-dashed mt-2"
          (click)="onAbrirGestao()">
  </button>
</div>
